// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tv-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-lg) var(--spacing-xl);
  background: rgba(0, 0, 0, 0.3);
  border-bottom: 1px solid var(--border-color);
  backdrop-filter: blur(10px);
}

.tv-header-left {
  display: flex;
  align-items: center;
  gap: var(--spacing-xl);
}

.tv-logo {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  color: var(--accent-blue);
}

.tv-logo-text {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
}

.tv-location-info {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-lg);
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
}

.tv-current-location {
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--text-primary);
}

.tv-location-count {
  font-size: 0.9rem;
  color: var(--text-muted);
  padding-left: var(--spacing-sm);
  border-left: 1px solid var(--border-color);
  margin-left: var(--spacing-sm);
}

.tv-header-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.tv-clock {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tv-time {
  font-size: 2.5rem;
  font-weight: 300;
  font-family: 'Monaco', 'Consolas', monospace;
  color: var(--text-primary);
  letter-spacing: 2px;
}

.tv-date {
  font-size: 1rem;
  color: var(--text-secondary);
}

.tv-header-right {
  display: flex;
  align-items: center;
  gap: var(--spacing-xl);
}

.tv-status {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--spacing-xs);
}

.tv-status-indicator {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-xs) var(--spacing-md);
  background: var(--bg-card);
  border-radius: var(--radius-md);
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.tv-status-indicator.cycling .status-dot {
  background: var(--accent-green);
  animation: pulse 2s infinite;
}

.tv-status-indicator.paused .status-dot {
  background: var(--accent-yellow);
}

.status-text {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.tv-last-update {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  font-size: 0.8rem;
  color: var(--text-muted);
}

.tv-controls {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs);
  background: var(--bg-card);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
}

.tv-control-btn {
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
}

.tv-control-btn:hover {
  background: var(--bg-card-hover);
  color: var(--text-primary);
}

.tv-control-btn.active {
  background: var(--accent-blue);
  color: white;
}

.tv-control-divider {
  width: 1px;
  height: 24px;
  background: var(--border-color);
  margin: 0 var(--spacing-xs);
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}`, "",{"version":3,"sources":["webpack://./src/components/TV/TVHeader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4CAA4C;EAC5C,8BAA8B;EAC9B,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,+BAA+B;EAC/B,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;EAC5C,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB","sourcesContent":[".tv-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-lg) var(--spacing-xl);\n  background: rgba(0, 0, 0, 0.3);\n  border-bottom: 1px solid var(--border-color);\n  backdrop-filter: blur(10px);\n}\n\n.tv-header-left {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xl);\n}\n\n.tv-logo {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  color: var(--accent-blue);\n}\n\n.tv-logo-text {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.tv-location-info {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-lg);\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-color);\n}\n\n.tv-current-location {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.tv-location-count {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  padding-left: var(--spacing-sm);\n  border-left: 1px solid var(--border-color);\n  margin-left: var(--spacing-sm);\n}\n\n.tv-header-center {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.tv-clock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tv-time {\n  font-size: 2.5rem;\n  font-weight: 300;\n  font-family: 'Monaco', 'Consolas', monospace;\n  color: var(--text-primary);\n  letter-spacing: 2px;\n}\n\n.tv-date {\n  font-size: 1rem;\n  color: var(--text-secondary);\n}\n\n.tv-header-right {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xl);\n}\n\n.tv-status {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: var(--spacing-xs);\n}\n\n.tv-status-indicator {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-xs) var(--spacing-md);\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n}\n\n.status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.tv-status-indicator.cycling .status-dot {\n  background: var(--accent-green);\n  animation: pulse 2s infinite;\n}\n\n.tv-status-indicator.paused .status-dot {\n  background: var(--accent-yellow);\n}\n\n.status-text {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.tv-last-update {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.tv-controls {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-xs);\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n}\n\n.tv-control-btn {\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n}\n\n.tv-control-btn:hover {\n  background: var(--bg-card-hover);\n  color: var(--text-primary);\n}\n\n.tv-control-btn.active {\n  background: var(--accent-blue);\n  color: white;\n}\n\n.tv-control-divider {\n  width: 1px;\n  height: 24px;\n  background: var(--border-color);\n  margin: 0 var(--spacing-xs);\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
